import { lazy } from 'react'

import type { RouteObject } from 'react-router'

import { IniciarAtendimentoPageSuspense } from '@/features/atendimento/chile/pages/iniciar-atendimento/suspense'
import { UltimosAtendimentosPageSuspense } from '@/features/atendimento/chile/pages/ultimos-atendimentos/suspense'

const UltimosAtendimentosPage = lazy(() =>
  import('@/features/atendimento/chile/pages/ultimos-atendimentos').then((module) => ({
    default: module.UltimosAtendimentosPage,
  })),
)

const IniciarAtendimentoPage = lazy(() =>
  import('@/features/atendimento/chile/pages/iniciar-atendimento').then((module) => ({
    default: module.IniciarAtendimentoPage,
  })),
)

export const chileAtendimentoRoutes: RouteObject[] = [
  {
    path: 'es-CL',
    children: [
      {
        index: true,
        element: (
          <UltimosAtendimentosPageSuspense>
            <UltimosAtendimentosPage />
          </UltimosAtendimentosPageSuspense>
        ),
      },
      {
        path: 'atendimento',
        children: [
          {
            path: 'iniciar',
            element: (
              <IniciarAtendimentoPageSuspense>
                <IniciarAtendimentoPage />
              </IniciarAtendimentoPageSuspense>
            ),
          },
        ],
      },
    ],
  },
]
